import { useCreateUrlWithQuery } from '../../hooks/useQuery';
import request from '../request';

export const getParticipants = ({ userId, orgId, parameters }) =>
  request.base.get(
    useCreateUrlWithQuery('v2/participant/getParticipant', parameters),
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const getPacePlans = ({ userId, orgId }) =>
  request.base.get(
    'v2/participant/pacePlans',
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const deleteParticipants = ({ userId, orgId, list }) =>
  request.base.delete(
    `v2/participant/deleteParticipant/${list}`,
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const updateParticipant = ({ userId, orgId, item }) =>
  request.base.post(
    'v2/participant/updateParticipant',
    {
      ...item,
    },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const addParticipant = ({ userId, orgId, item }) =>
  request.base.put(
    'v2/participant/addParticipant',
    {
      ...item,
    },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const getParticipantPlan = ({ userId, orgId, participantId }) =>
  request.base.get(
    `v2/participant/getParticipantPlan/${participantId}`,
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const getBudget = ({ userId, orgId, parameters }) =>
  request.base.get(
    useCreateUrlWithQuery('v2/participant/budget', parameters),
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const addBudget = ({ userId, orgId, item }) =>
  request.base.put(
    'v2/participant/budget',
    { ...item },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const updateBudget = ({ userId, orgId, item }) =>
  request.base.post(
    'v2/participant/budget',
    { ...item },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const deleteBudget = ({ userId, orgId, list }) =>
  request.base.delete(
    `v2/participant/budget/${list}`,
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const getFinancialContact = ({ userId, orgId, parameters }) =>
  request.base.get(
    useCreateUrlWithQuery('v2/participant/contact', parameters),
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const updateFinancialContact = ({ userId, orgId, item }) =>
  request.base.post(
    `v2/participant/contacts/${item.contactId}`,
    { ...item },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );
export const addFinancialContact = ({ userId, orgId, item }) =>
  request.base.put(
    'v2/participant/contact',
    { ...item },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const deleteFinancialContact = ({ userId, orgId, list }) =>
  request.base.delete(
    `v2/participant/contact/${list}`,
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );
export const downloadParticipantImportSampleExcel = ({ userId, orgId }) =>
  request.base.get(
    'v2/participant/importTemplate',
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );
export const importExcelParticipantData = ({ userId, orgId, item }) =>
  request.base.post(
    'v2/participant/importExcelParticipant',
    { ...item },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const getExcelOfParticipant = ({ userId, orgId }) =>
  request.base.get(
    'v2/participant/exportParticipantExcelLink',
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const getExcelOfParticipantPlan = ({ userId, orgId, participantId }) =>
  request.base.get(
    `v2/participant/exportParticipantPlanExcelLink/${participantId}`,
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const getExcelOfParticipantServiceBooking = ({ userId, orgId, participantId }) =>
  request.base.get(
    `v2/participant/exportParticipantSBExcelLink/${participantId}`,
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );
